import { useDispatch, useSelector } from 'react-redux';
import { setClearAllState, setFile } from '../store/actions/rsoImportActions';
import { message } from 'antd';
import { ALLOWED_FILE_EXT } from '../constants/constants';

const useUpdateFile = (handleFileChange, form) => {
  const { resetFields } = form || {};
  const dispatch = useDispatch();
  const { file } = useSelector((state) => state.rsoImportStore);

  const updateFile = (e) => {
    const fileTest = e.target.files?.[0];

    if (!fileTest) {
      e.target.value = '';
      return;
    }

    const fileNameTest = fileTest.name;
    const fileExt = fileNameTest.split('.').pop().toLowerCase();

    if (!ALLOWED_FILE_EXT.includes(fileExt)) {
      message.error(
        'Неверный формат, пожалуйста, загрузите файл в формате .xlsx',
        3
      );
      e.target.value = '';
      return;
    }

    if (file) {
      resetFields();
      dispatch(setClearAllState());
    }

    dispatch(setFile(fileTest));
    handleFileChange(fileTest);
  };

  return updateFile;
};
export default useUpdateFile;
